function kkmhhybrid_get_partner_userinfo (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "get_partner_userinfo",
    },
    param: {
      platform: opt.platform
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}

/**
 * 退出webview<br>
 * kkmhhybrid://get_partner_userinfo{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=239435915}<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.platform 打开平台名称，目前支持qq，添加时间2020-10-11
 * @param {Function} opt.callback 回调函数
 */
function get_partner_userinfo (opt) {
  kkmhhybrid_get_partner_userinfo(opt);
}

export default get_partner_userinfo;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/get_partner_userinfo/index.js